"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var MyAccountRoutes;
(function (MyAccountRoutes) {
    MyAccountRoutes["INDEX"] = "/";
    MyAccountRoutes["MYACCOUNT_BASE"] = "/my-account";
    MyAccountRoutes["MYACCOUNT_ORDERS"] = "/my-account/orders";
    MyAccountRoutes["MYACCOUNT_RESERVATIONS"] = "/my-account/reservations";
    MyAccountRoutes["MYACCOUNT_ENQUIRY"] = "/my-account/enquiry";
    MyAccountRoutes["MYACCOUNT_PERSONAL_DETAILS"] = "/my-account/personal-details";
    MyAccountRoutes["MYACCOUNT_DELIVERY_ADDRESS"] = "/my-account/delivery-address";
    MyAccountRoutes["MYACCOUNT_DRIVERS_LICENSE_DETAILS"] = "/my-account/drivers-license-details";
    MyAccountRoutes["MYACCOUNT_CHANGE_PASSWORD"] = "/my-account/change-password";
    MyAccountRoutes["MYACCOUNT_REGISTRATION_CONFIRMATION"] = "/registration-confirmation";
    MyAccountRoutes["MYACCOUNT_FINANCE"] = "/my-account/finance/*";
    MyAccountRoutes["MYACCOUNT_FINANCE_REDIRECTION"] = "/my-account/finance";
    MyAccountRoutes["MYACCOUNT_FORGOT_PASSWORD"] = "/my-account/forgot-password";
    MyAccountRoutes["MYACCOUNT_RESET_PASSWORD"] = "/my-account/reset-password";
    MyAccountRoutes["MYACCOUNT_INSURANCE"] = "/my-account/insurance";
    MyAccountRoutes["MYACCOUNT_LOGIN"] = "/my-account/login";
    MyAccountRoutes["MYACCOUNT_SET_PASSWORD"] = "/my-account/set-password";
    MyAccountRoutes["MYACCOUNT_SAVED_CARS"] = "/my-account/saved-cars";
})(MyAccountRoutes = exports.MyAccountRoutes || (exports.MyAccountRoutes = {}));
